export function Jumbotron() {
    return <div className="jumbotron mb-5">
      <div className="p-5">
        <div className="container-fluid py-2">
          <h1 className="display-1 text-center fw-bold">Q-ify</h1>
          <p className="lead text-center">Queue me.</p>
        </div>
      </div>
    </div>
}